// src/components/home/Agents/Agents.jsx
import React, { useEffect, useState } from "react";
import { FaFacebookF } from "react-icons/fa6";

import { motion } from "framer-motion";
import whatsappLink from "../../utils/whatsappLink";
import {
  FiPhoneCall,
  FiMail,
  FiArrowUpRight,
  FiBriefcase,
} from "react-icons/fi";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import "./Agents.css";
import apis from "../../utils/apis";
import httpAction from "../../utils/httpAction";



function AgentCard({ agent }) {
  return (
    <div className="agCard">
      <img
        src={apis().localUrl + agent?.imageUrl}
        alt={agent?.name}
        className="agCard__img"
      />

      <div className="agCard__body">
        <h3 className="agCard__name">{agent?.name}</h3>
        <p className="agCard__role">{agent?.desigination}</p>

        <div className="agCard__meta">
          <span>
            <FiBriefcase /> {agent?.experience} Yaers of experience
          </span>
          <span>{agent?.branch}</span>
        </div>

        <div className="agCard__actions">
          <a
            href={whatsappLink(
              agent?.mobile,
              "Hi there i am intrested in your listings",
              window.location.href
            )}
          >
            <button title="Call">
              <FiPhoneCall />
            </button>
          </a>
          <button
            onClick={() => {
              window.location.href = agent?.facebook || apis().facebookLink;
            }}
            title="Email"
          >
            <FaFacebookF />
          </button>
          {/* <button title="Profile">
            <FiArrowUpRight />
          </button> */}
        </div>
      </div>
    </div>
  );
}

export default function Agents() {
  const [list, setList] = useState([]);

  const getAgents = async () => {
    const data = {
      url: apis().getUserList + "?limit=8",
    };
    const result = await httpAction(data);
    if (result?.status) {
      setList(result?.list);
    }
  };

  useEffect(() => {
    getAgents();
  }, []);

  return (
    <section className="ag">
      <div className="container">
        <motion.div
          className="ag__head"
          initial={{ opacity: 0, y: 14 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <div>
            <span className="ag__kicker">Our Team</span>
            <h2 className="ag__title">Meet Our Agents</h2>
            <p className="ag__sub">
              Our experienced agents are here to guide you through every step —
              from shortlisting to closing.
            </p>
          </div>

          <button className="ag__cta">
            View All Agents <FiArrowUpRight />
          </button>
        </motion.div>

        <Swiper
          modules={[Navigation, Pagination,Autoplay]}
             autoplay={{
                delay: 1000, // Change to the desired delay (4000ms = 4 seconds)
                disableOnInteraction: false, // Autoplay continues even after user interaction
              }}
    
          pagination={{ clickable: true }}
          spaceBetween={16}
          slidesPerView={1}
          breakpoints={{
            576: { slidesPerView: 1.2 },
            768: { slidesPerView: 2 },
            992: { slidesPerView: 3 },
            1200: { slidesPerView: 4 },
          }}
          className="ag__swiper"
        >
          {list?.map((a) => (
            <SwiperSlide key={a._id}>
              <AgentCard agent={a} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}
